<template>
  <div>
    <div class="condition-section">
      <div class="cond-row">
        <div class="item">
          <div style="margin-right: 10px">企业名称：</div>
          <Input
            class="height45"
            v-model="qy"
            placeholder="请输入搜索的名称"
            style="width: 300px"
            clearable
          />
        </div>
        <div class="item">
          <Button
            class="btn-height45"
            type="primary"
            style="margin-right: 20px"
            @click="onSearch"
            >搜索</Button
          >
          <Button
            class="btn-height45"
            @click="onSearchCancel"
            style="margin-right: 20px"
            >重置</Button
          >
          <Button
            class="btn-height45"
            type="primary"
            @click="updateEnCertifiedModalVisibility = true"
            >添加公司认证</Button
          >
        </div>
      </div>
    </div>
    <div class="table-data">
      <div class="total">搜索结果（{{ total }}）</div>
      <Table
        class="domain-table"
        :columns="columns"
        :data="data"
        :loading="tableLoading"
      >
        <template slot="status" slot-scope="{ row }">
          <div>
            {{ row.status | status }}
          </div>
        </template>
        <template slot="action" slot-scope="{ row }">
          <div>
            <Button @click="onDeleteItem(row)">删除</Button>
          </div>
        </template>
      </Table>
      <div class="page-tool">
        <Page
          :current="page"
          :total="total"
          :page-size="limit"
          @on-change="onPageChange"
        />
      </div>
    </div>
    <updateEnCertifiedModal
      :show.sync="updateEnCertifiedModalVisibility"
      @submit-success="onSuccess"
    ></updateEnCertifiedModal>
  </div>
</template>

<script>
import { enterpriseIdentityList, enterpriseIdentityDelete } from "api/customer.js";
import updateEnCertifiedModal from "components/account/updateEnCertifiedModal.vue";

export default {
  name: "myEnterprise",
  components: {
    updateEnCertifiedModal,
  },
  filters: {
    status(val) {
      let title = "";
      switch (val) {
        case 0:
          title = "认证中";
          break;
        case 1:
          title = "认证成功";
          break;
        case 2:
          title = "认证失败";
          break;
      }
      return title;
    },
  },
  data() {
    return {
      qy: "",
      page: 1,
      limit: 20,
      total: 0,
      columns: [
        {
          title: "序号",
          align: "center",
          type: "index",
        },
        {
          title: "企业名称",
          align: "center",
          key: "qy",
        },
        {
          title: "证件号码",
          align: "center",
          key: "num",
        },
        {
          title: "提交时间",
          align: "center",
          key: "createdTime",
        },
        {
          title: "状态",
          align: "center",
          slot: "status",
        },
        {
          title: "操作",
          align: "center",
          slot: "action",
        },
      ],
      data: [],
      tableLoading: false,
      updateEnCertifiedModalVisibility: false,
    };
  },
  created() {
    this.req_getList();
  },
  methods: {
    // 请求
    async req_getList() {
      try {
        const params = {
          qy: this.qy,
          page: this.page,
          limit: this.limit,
        };
        this.tableLoading = true;
        const { code, data } = await enterpriseIdentityList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.list;
          this.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 跳页
    onPageChange(val) {
      this.page = val;
      this.req_getList();
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.qy = "";
      this.onPageChange(1);
    },
    async onSuccess(callback) {
      await this.req_getList();
      callback(true);
    },
    // 取消转出
    onDeleteItem(val) {
      this.$Modal.confirm({
        title: "删除确认",
        content: "<p>确定要删除此企业认证吗？</p>",
        onOk: async () => {
          const res = await enterpriseIdentityDelete(val.id);
          if (res.code === 200 && res.result) {
            this.$Message.success("删除成功！");
            this.req_getList();
          }
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.condition-section {
  margin: 15px;
  background-color: #fff;
  padding: 20px 20px;
  .cond-row {
    display: flex;
    flex-wrap: wrap;
    line-height: 60px;
    .item {
      display: flex;
      align-items: center;
      margin: 0 20px;
    }
  }
}
.tname {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}
.total {
  line-height: 80px;
  font-size: 18px;
  color: #3992e9;
  font-weight: bold;
}
.table-data {
  margin: 40px 0;
  background-color: #fff;
  padding: 20px 20px;
}
.page-tool {
  margin-top: 40px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.domain-table {
  .ivu-table-header th {
    background-color: #315491;
  }
  .ivu-table-header th,
  .ivu-table-body td {
    height: 60px;
  }
  .ivu-table-tip {
    td {
      line-height: 300px;
    }
  }
}
</style>
<style lang="less" scoped>
/deep/.height45 {
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
.btn-height45 {
  height: 45px;
  line-height: 45px;
  min-width: 80px;
}
</style>
